import React from 'react'
import { signUpUrlWithQuery } from 'helpers/format'

export default props => {
  return (
    <div className="signup-box signup-box__new-account">
      <div className="row">
        <div className="signup-box__new-account-txt col-sm-12">
          <a
            href={signUpUrlWithQuery(props.config.URL)}
            className="signup-box__new-account-title"
          >
            まだアカウントの無い方は<span className="signup-box__new-account-linktxt">
              新規登録
            </span>
            <i className="fas fa-angle-right" />
          </a>
        </div>
      </div>
    </div>
  )
}
